module.exports = __webpack_public_path__ + "static/media/left-chevron.4030d06a.svg";